import ModalInfo from 'components/templates/modalInfo/ModalInfo';
import Button from 'components/commons/buttons/button/Button';

import './modalInfoSuccess.scss';

interface IModalInfoSucces {
    title: string;
    text?: string
    onClose?: () => void;
    onAccept?: () => void;
    textClose?: string;
    textAccept?: string;
}

export default function ModalInfoSuccess ({ onClose, title, text, onAccept, textClose, textAccept}: IModalInfoSucces) {

    return (
        <ModalInfo title={title} width='400px' height='auto'>
            <div className='modal-success'>
                {text && <div className='modal-success-text'>
                    {text}
                </div>}
                <div className='modal-success-actions'>
                    {onClose && <Button title={textClose ?? 'Cerrar'} className='modal-success-btn-cancelar' onClick={()=> onClose()}/>}
                    {onAccept && <Button title={textAccept ?? 'Aceptar'} className='modal-success-btn-aceptar' onClick={()=> onAccept()}/>}
                </div>
            </div>
        </ModalInfo>
    );
};
